import React, {useMemo} from 'react';
import {observer} from 'mobx-react-lite';
import {injectIntl} from 'react-intl';
import classNames from 'classnames';
import {AppContext} from '../../../store';
import {ReactComponent as SignOutImg} from '../../../assets/images/icons/header/sign-out.svg';
import {ReactComponent as MoostooLogoImg} from '../../../assets/images/m-logo-long.svg';
import {ReactComponent as SideBarIcon} from '../../../assets/images/icons/sidebar-toggle.svg';
import {AccountCircle} from '@mui/icons-material';

import {ReactComponent as HomeIcon} from '../../../assets/images/icons/icon-home.svg';
import {ReactComponent as PeopleIcon} from '../../../assets/images/icons/icons-network.svg';
import {ReactComponent as CalendarIcon} from '../../../assets/images/icons/icons-my-agenda.svg';
import {ReactComponent as ChatIcon} from '../../../assets/images/icons/icon-chat.svg';


import './NavBar.scss';
import styles from './NavBar.module.scss'
import MenuItem from "./MenuItem";
import {useLocation} from "react-router-dom";

const NavBar = observer(() => {
    const {chatStore, userStore, eventStore, uiStore, modalStore} = React.useContext(AppContext);
    const {getUnSeenMessages} = chatStore;
    const {isMenuCollapsed} = uiStore;
    const {eventDetails} = eventStore;
    const canCheckIn = eventDetails && eventDetails.me.checkInAdmin && !eventDetails.isFinished;
    const canInvite = eventDetails?.me?.rights?.inviteparticipant;
    const location = useLocation();

    const activeMenu = useMemo(() => {
        if (location.pathname.startsWith('/event')) {
            return 'events';
        }
        if (location.pathname.startsWith('/account')) {
            return 'profile';
        }
        if (location.pathname.includes('invitations')) {
            return 'invitations';
        }
        if (location.pathname.includes('chat')) {
            return 'chats';
        }
        if (location.pathname.includes('agenda')) {
            return 'agenda';
        }
        return '';
    }, [location.pathname]);

    const classes = classNames('nav-bar', {
        'nav-bar--close': isMenuCollapsed,
        'nav-bar--open': !isMenuCollapsed,
    });

    return (
        <div className={styles.navBar}>
            <div className={styles.header}>
                <div className={styles.iconContainer} onClick={() => uiStore.triggerMainMenu(!isMenuCollapsed)}>
                    <MoostooLogoImg className={styles.logo}/>
                    <SideBarIcon className={styles.sidebarIcon} onClick={() => uiStore.triggerMainMenu(!isMenuCollapsed)}/>
                </div>
                <MenuItem active={activeMenu === "profile"} icon={<AccountCircle />} text={'Profile'} href={'/account'} />
            </div>
            <div className={styles.menu}>
                <MenuItem active={activeMenu === 'events'} icon={<HomeIcon />} text={'Events'} href={'/event/list'} />
                <MenuItem active={activeMenu === 'invitations'} icon={<PeopleIcon />} text={'Invitations'} href={'/invitations'} />
                <MenuItem active={activeMenu === 'chats'} icon={<ChatIcon />} text={'Chats'} href={'/'} />
                <MenuItem active={activeMenu === 'my-agenda'} icon={<CalendarIcon />} text={'My Agenda'} href={'/'} />
            </div>
            <div className={styles.menuRest}>
                <MenuItem icon={<SignOutImg />} text={'Sign Out'} onClick={() => userStore.logout()} />
            </div>
        </div>
    );
});

export default injectIntl(NavBar);
